import React from "react"

function TeamA() {
  return (
    <svg fill="none" viewBox="0 0 266 150">
      <path fill="var(--solid)" d="M0 0h266v150H0z" />
      <rect
        x={110}
        y={20}
        width={46}
        height={5}
        rx={2.5}
        fill="var(--solid-900)"
      />
      <rect x={87} y={29} width={92} height={4} rx={2} fill="var(--base-500)" />
      <rect
        x={44}
        y={52}
        width={39}
        height={3}
        rx={1.5}
        fill="var(--solid-900)"
      />
      <rect
        x={44}
        y={58}
        width={20}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <circle cx={31.5} cy={56.5} r={7.5} fill="var(--base-300)" />
      <rect
        x={20.5}
        y={45.5}
        width={69}
        height={22}
        rx={1.5}
        stroke="var(--base-400)"
      />
      <rect
        x={122}
        y={52}
        width={39}
        height={3}
        rx={1.5}
        fill="var(--solid-900)"
      />
      <rect
        x={122}
        y={58}
        width={20}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <circle cx={109.5} cy={56.5} r={7.5} fill="var(--base-300)" />
      <rect
        x={98.5}
        y={45.5}
        width={69}
        height={22}
        rx={1.5}
        stroke="var(--base-400)"
      />
      <rect
        x={200}
        y={52}
        width={39}
        height={3}
        rx={1.5}
        fill="var(--solid-900)"
      />
      <rect
        x={200}
        y={58}
        width={20}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <circle cx={187.5} cy={56.5} r={7.5} fill="var(--base-300)" />
      <rect
        x={176.5}
        y={45.5}
        width={69}
        height={22}
        rx={1.5}
        stroke="var(--base-400)"
      />
      <rect
        x={44}
        y={83}
        width={39}
        height={3}
        rx={1.5}
        fill="var(--solid-900)"
      />
      <rect
        x={44}
        y={89}
        width={20}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <circle cx={31.5} cy={87.5} r={7.5} fill="var(--base-300)" />
      <rect
        x={20.5}
        y={76.5}
        width={69}
        height={22}
        rx={1.5}
        stroke="var(--base-400)"
      />
      <rect
        x={122}
        y={83}
        width={39}
        height={3}
        rx={1.5}
        fill="var(--solid-900)"
      />
      <rect
        x={122}
        y={89}
        width={20}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <circle cx={109.5} cy={87.5} r={7.5} fill="var(--base-300)" />
      <rect
        x={98.5}
        y={76.5}
        width={69}
        height={22}
        rx={1.5}
        stroke="var(--base-400)"
      />
      <rect
        x={200}
        y={83}
        width={39}
        height={3}
        rx={1.5}
        fill="var(--solid-900)"
      />
      <rect
        x={200}
        y={89}
        width={20}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <circle cx={187.5} cy={87.5} r={7.5} fill="var(--base-300)" />
      <rect
        x={176.5}
        y={76.5}
        width={69}
        height={22}
        rx={1.5}
        stroke="var(--base-400)"
      />
      <rect
        x={44}
        y={114}
        width={39}
        height={3}
        rx={1.5}
        fill="var(--solid-900)"
      />
      <rect
        x={44}
        y={120}
        width={20}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <circle cx={31.5} cy={118.5} r={7.5} fill="var(--base-300)" />
      <rect
        x={20.5}
        y={107.5}
        width={69}
        height={22}
        rx={1.5}
        stroke="var(--base-400)"
      />
      <rect
        x={122}
        y={114}
        width={39}
        height={3}
        rx={1.5}
        fill="var(--solid-900)"
      />
      <rect
        x={122}
        y={120}
        width={20}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <circle cx={109.5} cy={118.5} r={7.5} fill="var(--base-300)" />
      <rect
        x={98.5}
        y={107.5}
        width={69}
        height={22}
        rx={1.5}
        stroke="var(--base-400)"
      />
      <rect
        x={200}
        y={114}
        width={39}
        height={3}
        rx={1.5}
        fill="var(--solid-900)"
      />
      <rect
        x={200}
        y={120}
        width={20}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <circle cx={187.5} cy={118.5} r={7.5} fill="var(--base-300)" />
      <rect
        x={176.5}
        y={107.5}
        width={69}
        height={22}
        rx={1.5}
        stroke="var(--base-400)"
      />
    </svg>
  )
}

export default TeamA;
